import React from 'react'
import './rajbhasha.css'

const RajBhasha = () => {
    return (
        <div>
            <h3 className='heading'>– राजभाषा - विभागीय गतिविधियां –</h3>
            <div className="faq-content-wrapper">
                <div className="faq">
                    <h2>This page is currently under development</h2>
                </div>
            </div>
        </div>
    )
}

export default RajBhasha
